import type {
  ComponentSettings,
  ComponentSettingsProps,
} from "@repo/editor/externalComponents";
import type { ComponentType } from "@repo/editor/types";
import { observer } from "mobx-react-lite";
import React, { forwardRef } from "react";
import * as t from "@rekajs/types";

export const departmentContactsItemDefinition: ComponentSettingsProps = {
  title: {
    type: "string",
    label: "عنوان",
  },
  name: {
    type: "string",
    label: "اسم",
  },
  phone: {
    type: "string",
    label: "تلفن همراه",
  },
  email: {
    type: "string",
    label: "ایمیل",
  },
};

interface DepartmentContactsItemProps {
  title: string;
  name: string;
  phone: string;
  email: string;
}

const DepartmentContactsItemComponent = forwardRef<
  HTMLDivElement,
  DepartmentContactsItemProps
>((props, ref) => {
  return (
    <div className="text-gray-700" ref={ref}>
      <h4 className="text-xl lg:text-2xl rtl:font-doran">{props.title}</h4>
      <ul className="mt-4 space-y-1 text-base lg:text-lg flex flex-col gap-1 font-sans">
        <li>• {props.name}</li>
        <li>• {props.phone}</li>
        <li>• {props.email}</li>
      </ul>
    </div>
  );
});

DepartmentContactsItemComponent.displayName = "DepartmentContactsItem";

export const DepartmentContactsItem = observer(
  DepartmentContactsItemComponent
) as unknown as ComponentType<DepartmentContactsItemProps>;

export const departmentContactsItemSettings: ComponentSettings = {
  name: "EDepartmentContactsItem",
  props: departmentContactsItemDefinition,
  label: "تماس با بخش آیتم",
  widgets: {
    label: "تماس با بخش آیتم",
    template: () =>
      t.componentTemplate({
        component: t.identifier({
          name: "EDepartmentContactsItem",
          external: true,
        }),
      }),
  },
};

DepartmentContactsItem.componentSettings = departmentContactsItemSettings;
